<template>
  <CContainer fluid>
    <h3>Facturas de Venta</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6">
            <CInput 
              label="Buscar: "
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
        </CRow>
        <CDataTable
          hover
          :items="bills"
          :fields="fields"
          :items-per-page="itemsPerPage"
          @row-clicked="(item, index, _columnName, e) => {
            e.preventDefault()
            goTo(item, 'detalle')
          }">
          <template #documento="{item}">
            <td>
              <div>
                <h4>{{ item.numero }}</h4>
                <p>{{ item.prefijo }}</p>
              </div>
            </td>
          </template>
          <template #empresa="{item}">
            <td>
              <div>
                <span>
                  <CIcon name="cil-building" class="mr-1"/>
                  {{ item.empresa }}
                </span>
              </div>
              <div>
                <span>
                  <i class="bi bi-postcard mr-1"></i>
                  {{ item.identificacion }}
                </span>
              </div>
              <div>
                <span>
                  <i class="bi bi-person-workspace mr-1"></i>
                  {{item.empleado}}
                </span>
              </div>
            </td>
          </template>
          <template #fechas="{item}">
            <td>
              <div>
                <span>
                  <CIcon name="cil-calendar" class="text-success mr-1"/>
                  {{moment(item.fecha_Emision).format('DD/MM/YYYY')}}
                </span>
              </div>
              <div>
                <span>
                  <CIcon name="cil-calendar" class="text-danger mr-1"/>
                  {{moment(item.fecha_Vencimiento).format('DD/MM/YYYY')}}
                </span>
              </div>
            </td>
          </template>
          <template #valores="{item}">
            <td>
              <div>
                <span>${{ formatter.format(item.valor_Mercancia, 0) }}</span>
              </div>
              <div>
                <span>${{formatter.format(item.valor_Iva, 0)}}</span>
              </div>
              <div>
                <strong>${{ formatter.format(item.valor_Total, 0) }}</strong>
              </div>
              <div>
                <CBadge 
                  class="text-white"
                  :color="getBadgeColor(item.estado_cartera)">
                  ${{ formatter.format(item.valor_Saldo, 0) }}
                </CBadge>
              </div>
            </td>
          </template>
          <template #detalles="{item}">
            <td>
              <a href="#"
                class="mb-2 p-2"
                style="text-decoration: none;"
                @click="toggleDocument($event, item)">
                <CIcon 
                  class="text-dark" 
                  :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'">
                </CIcon>
              </a>
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <div class="d-flex justify-content-end mb-3">
                <a href="#" 
                  class="mr-3" 
                  v-c-tooltip="'Movimiento de factura'"
                  @click="openPanelKardex($event, item.id_Documento)">
                  <i class="bi bi-journal-text text-info h4"></i>
                </a>
                <a href="#" 
                  class="mr-3" 
                  v-c-tooltip="'Seriales'" 
                  @click="openModalSeriales($event, item.id_Documento)">
                  <i class="bi bi-upc-scan text-dark h4"></i>
                </a>

                <!-- ToDo -->
                <a href="#" 
                  class="mr-3" 
                  v-c-tooltip="'Carga Documentos Anexos'"
                  @click="openPanelUploadAttachment($event, item.id_Documento)">
                  <Icon icon="fluent:document-arrow-up-20-regular" class="text-s3fuchsia h3" />
                </a>


                <a href="#" 
                  class="mr-3" 
                  v-c-tooltip="'Documentos Anexos'" 
                  @click="openPanelAttachments($event, item.id_Documento)">
                  <Icon icon="teenyicons:attachment-outline" class="text-s3brown h4" />
                </a>

                <a href="#" 
                  class="mr-3" 
                  v-c-tooltip="'Eventos de la Factura'" 
                  @click="(event) => openPanelEvents(event, item.cude)">
                  <i class="bi bi-ui-checks-grid h4"></i>
                </a>

                <a href="#" 
                  class="mr-3" 
                  v-c-tooltip="'Descargas Documentos DIAN'" 
                  @click="openPanelDownloadDocumentsDIAN($event, item.id_Documento)">
                  <Icon icon="lucide:folder-down" class="text-s3violet h3" />
                </a>
                <a href="#"
                  class="mr-3"
                  v-c-tooltip="'Registro DIAN'"
                  @click="getUrlElectronicDocument($event, item.cude)">
                  <Icon icon="icon-park-outline:copy-link" class="text-s3green h4" />
                </a>

                <!-- ToDo -->
                <!-- <a href="#" 
                  class="mr-3">
                  <Icon icon="mdi:truck-fast-outline" class="text-s3brown h2" />
                </a> -->

              </div>
              <CCol sm="6" class="d-inline-block" style="vertical-align: top;">
                <div class="ml-4"><strong>Comentarios: </strong></div>
                <div class="ml-4"><strong></strong>{{item.comentario_01}}</div>
                <div class="ml-4"><strong></strong>{{item.comentario_02}}</div>
              </CCol>
              <CCol sm="3" class="d-inline-block">
                <div class="ml-4"><strong>ReteFuente: </strong>{{item.valor_ReteFuente}}</div>
                <div class="ml-4"><strong>ReteIva: </strong>{{item.valor_ReteIva}}</div>
                <div class="ml-4"><strong>ReteIca: </strong>{{item.valor_ReteIca}}</div>
              </CCol>
              <CCol sm="3" class="d-inline-block">
                <div class="ml-4"><strong>Subtotal: </strong>{{formatter.format(item.valor_Mercancia, 0)}}</div>
                <div class="ml-4"><strong>IVA: </strong>{{formatter.format(item.valor_Iva, 0)}}</div>
                <div class="ml-4"><strong>Total: {{formatter.format(item.valor_Total, 0)}}</strong></div>
              </CCol>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination
          class="d-flex justify-content-center"
          size="sm"
          :activePage.sync="page"
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)"
        />
      </CCardBody>

      <LoadingCover v-show="loading" />
    </CCard>

    <RightSideBar size="lg" :show="showPanelKardex" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-4">
          <CCardHeader>
            <CCardTitle>
              Productos Facturados
            </CCardTitle>
            <CCardSubtitle>
              Detalle de los productos facturados
            </CCardSubtitle>
          </CCardHeader>
          <CCardBody>
            <div class="panel-scroll">
              <DocumentKardex :idDocument="idDocumento" :key="updateComponent" />
            </div>
          </CCardBody>
        </CCard>
        <div class="d-flex justify-content-center">
          <CButton 
            color="primary"
            @click="showPanelKardex=false">
            <span class="align-middle">Cerrar</span>
          </CButton>
        </div>
      </CContainer>
    </RightSideBar>

    <RightSideBar size="lg" :show="showPanelSeriales" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Seriales Factura de Venta
            </CCardTitle>
            <CCardSubtitle>
              Detalle de los productos con sus respectivos seriales
            </CCardSubtitle>
          </CCardHeader>
          <CCardBody>
            <ProductSerialsDocument :idDocument="idDocumento" :key="updateComponent" />
          </CCardBody>
        </CCard>
        <div class="d-flex justify-content-center">
          <CButton 
            color="primary"
            @click="showPanelSeriales=false">
            <span class="align-middle">Cerrar</span>
          </CButton>
        </div>
      </CContainer>
    </RightSideBar>

    <RightSideBar :show="showPanelDownloadDocumentsDIAN" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Descarga de documentos DIAN
            </CCardTitle>
            <CCardSubtitle>
              <small>
                Descargue los diferentes tipos de documentos relacionados con la factura de venta electronica ante la DIAN.
              </small>
            </CCardSubtitle>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="sm-12">
                <CCallout color="danger">
                  <div class="d-flex justify-content-middle puntero" 
                    @click="downloadElectronicDocument($event, idDocument, 'PDF')">
                    <i class="bi bi-file-earmark-pdf text-danger h1 mr-2"></i>
                    <small>Representaci&oacute;n gr&aacute;fica de la factura electr&oacute;nica en PDF</small>
                  </div>
                </CCallout>
              </CCol>
              <CCol col="sm-12">
                <CCallout color="success">
                  <div class="d-flex justify-content-middle puntero" 
                    @click="downloadElectronicDocument($event, idDocument, 'XML')">
                    <i class="bi bi-filetype-xml text-success h1 mr-2"></i>
                    <small>Archivo XML de la factura electronica DIAN.</small>
                  </div>
                </CCallout>
              </CCol>
              <CCol col="sm-12">
                <CCallout
                  color="warning" >
                  <div class="d-flex justify-content-middle puntero" 
                    @click="downloadElectronicDocument($event, idDocument, 'ZIP')">
                    <i class="bi bi-file-earmark-zip text-warning h1 mr-2"></i>
                    <small>Archivo ZIP con el XML y el PDF de la factura electronica DIAN.</small>
                  </div>
                </CCallout>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
        <div class="d-flex justify-content-center">
          <CButton 
            color="primary" 
            @click="showPanelDownloadDocumentsDIAN=false">
            <CIcon name="cil-x-circle"></CIcon>
            <span class="align-middle ml-2">Cerrar</span>            
          </CButton>
        </div>
      </CContainer>
    </RightSideBar>

    <RightSideBar size="md" class="bg-s3grey" :show="showPanelUploadAttachment">
      <FormAttachments 
        :idDocument="idDocumento" 
        :key="updateComponentAttachments" 
        @closeWindow="closePanelAttachments">
      </FormAttachments>
    </RightSideBar>

    <RightSideBar size="lg" class="bg-s3grey" :show="showPanelAttachments">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Documentos Anexos
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <AttachedDocuments v-if="showPanelAttachments" 
              typeQuery="documento" 
              :id="idDocumento">
            </AttachedDocuments>
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify content-center">
              <CButton 
                color="primary"
                class="ml-2"
                @click="showPanelAttachments=false">
                <CIcon name="cil-x-circle"></CIcon>
                <span class="align-middle ml-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

    <RightSideBar size="md" class="bg-s3grey" :show="showPanelEventsDocuments">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader class="bg-s3skyblue">
            <CCardTitle>
              Eventos del Documento
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <EventsDocumentPanel :uuid="uuid_DIAN" :key="updateComponent" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify content-center">
              <CButton 
                color="primary"
                class="ml-2"
                @click="showPanelEventsDocuments=false">
                <CIcon name="cil-x-circle"></CIcon>
                <span class="align-middle ml-2">Cerrar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

  </CContainer>
</template>

<style>
  .panel-scroll {
    overflow-y: scroll;
    height: 60dvh;
    max-height: 100dvh;
  }
</style>

<script>
  import moment from "moment";
  import { Icon } from "@iconify/vue2";
  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import { formatter } from "@/general";
  import CONSTANTS from "@/constants";
  import { 
    downloadFileObject, 
    dataGridDocumentos 
  } from '../../api'
  import { descargarFacturaElectronica } from "@/apiReports";

  import RightSideBar from "../containers/RightSideBar.vue"
  import DocumentKardex from "../datagrids/DocumentKardex.vue"
  import ProductSerialsDocument from "../datagrids/ProductSerialsDocument.vue"
  import FormAttachments from "../forms/FormAttachments.vue"
  import AttachedDocuments from "../datagrids/AttachedDocuments.vue";
  import EventsDocumentPanel from "@/components/panels/EventsDocumentPanel.vue";

  const fields = [
    {
      key: 'documento', 
      label: 'Documento',
      _style:'text-align:center;'
    },
    {
      key: 'empresa', 
      label: 'Empresa',
      _style:'text-align:center;'
    },
    {
      key: 'fechas', 
      label: 'Fechas',
      _style:'text-align:center;'
    },
    {
      key: 'valores', 
      label: 'Valores',
      _style:'text-align:center;'
    },
    {
      key: 'detalles',
      label: ''
    }
  ]

export default {
  data() {
    return {
      formatter,
      loading: false,
      showPanelSeriales: null,
      showPanelKardex: null,
      showPanelAttachments: null,
      showPanelUploadAttachment: null,
      showPanelDownloadDocumentsDIAN: null,
      showPanelEventsDocuments: null,
      updateComponent: 0,
      updateComponentAttachments: 0,
      page: 1,
      pageCount: 1,
      itemsPerPage: 5,
      searchWord: '',
      fields,
      bills: [],
      idDocumento: "",
      uuid_DIAN: ""
    }
  },
  components: {
    Icon,
    RightSideBar,
    LoadingCover,
    DocumentKardex,
    ProductSerialsDocument,
    FormAttachments,
    AttachedDocuments,
    EventsDocumentPanel
},
  methods: {
    moment,
    async getData(page, search) {
      this.loading = true
      
      try {
        this.searchWord = search
        const { count, results } = await dataGridDocumentos(
          this,
          this.$store.state.user.data.tipo_Empleado === "V" ? this.$store.state.user.data.id_Empleado : null,
          null,
          page,
          search,
          'FacturasVenta'
        )
        this.pageCount = parseInt(count / this.itemsPerPage)
        if (this.pageCount < (count / this.itemsPerPage)) {
          this.pageCount++
        }
        this.bills = results
      } catch (error) {
        this.$store.commit('setAlert', {
          color: "danger",
          message: 'Error al cargar datos',
          show: 5
        })
      } finally{
        this.loading = false
      }        
    },
    async downloadElectronicDocument(e, idDocument, typeDocument) {
      e.preventDefault();
      e.stopPropagation()

      this.loading = true

      try {
        const { response } = await descargarFacturaElectronica(this, idDocument, typeDocument)
        const { nombreArchivo, contenidoArchivo } = response

        downloadFileObject(nombreArchivo, typeDocument, contenidoArchivo);
      } catch(error) {
        this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error al descargar el archivo de facturación electrónica.",
            show: 5
          })
      } finally {
        this.loading = false
      }
    },
    getUrlElectronicDocument(e, cude) {
      e.stopPropagation()

      if (cude) {
        const urlDocumentDIAN = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${cude}`

        window.open(urlDocumentDIAN, "_blank")
      } else {
        this.$alert("¡La factura aun no se ha transmitido a la DIAN!", "", "warning", CONSTANTS.configSimpleAlert)
      }
    },
    openPanelKardex(e, idDocument) {
      e.preventDefault();
      e.stopPropagation();

      this.showPanelKardex = true
      this.idDocumento = idDocument
      this.updateComponent += 1
    },
    openModalSeriales(e, idDocument) {
      e.preventDefault();
      e.stopPropagation()

      this.showPanelSeriales = true
      this.idDocumento = idDocument
      this.updateComponent += 1
    },
    openPanelUploadAttachment(e, idDocument) {
      e.preventDefault();
      e.stopPropagation()

      this.idDocumento = idDocument
      this.updateComponentAttachments++
      this.showPanelUploadAttachment = true
    },
    openPanelAttachments(e, idDocument) {
      e.preventDefault();
      e.stopPropagation()

      this.showPanelAttachments = true
      this.idDocumento = idDocument
      this.updateComponentAttachments++
    },
    closePanelAttachments() {
      this.showPanelUploadAttachment = false
    },
    openPanelDownloadDocumentsDIAN(e, idDocument) {
      e.preventDefault();
      e.stopPropagation()

      this.showPanelDownloadDocumentsDIAN = true
      this.idDocument = idDocument
    },
    openPanelEvents(e, id) {
      e.preventDefault();
      e.stopPropagation();

      this.showPanelEventsDocuments = true;
      this.uuid_DIAN = id;
      this.updateComponent += 1;
    },
    toggleDocument(e, item){
      e.preventDefault();
      e.stopPropagation()

      this.$set(item, '_toggled', !item._toggled)
      this.$nextTick(() => { })
    },
    getBadgeColor(estado) {      
      if(estado === 'Corriente') return 'success'
      if(estado === 'Vencida') return 'warning'
      if(estado === 'Morosa') return 'danger'
    }
  },
  mounted() {
    this.getData(this.page)    
  }
}
</script>